import { useTranslation } from "react-i18next";
import type { ActiveStorageUpload } from "@/lib/storageUpload";
import { TruncatedText } from "@/components/ui";
import { StorageUploadProgressBar } from "./StorageUploadProgressBar";

interface StorageUploadProgressBannerProps {
  upload: ActiveStorageUpload;
}

export function StorageUploadProgressBanner({
  upload,
}: StorageUploadProgressBannerProps) {
  const { t } = useTranslation("components");

  return (
    <div className="rounded-lg border border-primary-200 bg-primary-50 px-4 py-3">
      <TruncatedText as="p" className="mb-2 text-sm text-surface-700">
        {t("storageUploadFileProgress", {
          name: upload.fileName,
          current: upload.fileIndex + 1,
          total: upload.fileCount,
        })}
      </TruncatedText>
      <StorageUploadProgressBar
        upload={upload}
        trackClassName="bg-primary-100"
        fillClassName="bg-primary-500"
        labelClassName="text-xs text-surface-500"
      />
    </div>
  );
}
